import Button from './Button';

// TODO: remove inline styles
const styles = {
    normal: {
        backgroundColor: '#f66',
        borderColor: '#f66',
        color: 'white',
    },
};

// TODO: remove pointless inheritance
export default class DangerFilledButton extends Button {
    /* eslint-disable class-methods-use-this */
    buttonStyles() { return styles; }
    /* eslint-enable class-methods-use-this */
}
